export default __webpack_public_path__ + "static/img12-dfc7215e41e820f243ef76e10fe85d68.webp";